import { useEffect, useState } from "react";
import { useWebshopApiClient } from "@/react/Webshop/providers/WebshopApiClientProvider";
// Language is used to reload the packages on language change
const useSubjectPackageList = (pictureSet, language = "", mobile = false) => {
    const [packageInfo, setPackageInfo] = useState(null);
    const [isLoading, setIsLoading] = useState(true);
    const webshopApiClient = useWebshopApiClient();
    useEffect(() => {
        if (!pictureSet) {
            return;
        }
        setIsLoading(true);
        console.log("Fetching new package list", pictureSet);
        webshopApiClient
            .getPackages(pictureSet.subject.uuid, mobile)
            .then((data) => {
            console.log("Loading package list complete");
            setIsLoading(false);
            setPackageInfo(data);
        });
    }, [pictureSet, language, mobile, webshopApiClient]);
    return {
        packageInfo,
        isLoading,
    };
};
export default useSubjectPackageList;
